//@ts-ignore
const filesOriginal = require.context(
    "../assets/wallpapers", // context folder
    false, //no nested folders
    /.*\.png/ // RegExp
);

//@ts-ignore
const filesPriview = require.context(
    "../assets/wallpapers/preview", // context folder
    false, //no nested folders
    /.*\.png/ // RegExp
);

export const getWallpapersPreviews = ()=>{
    const list: string[] = [];
    filesPriview.keys().forEach((it:string)=>{
        list.push(it);
    });
    return list;
};

export const getWallpaperPreviewByKey = (key:string) => {
    return filesPriview(key);
}

export const getWallpaperByKey = (key:string) => {
    return filesOriginal(key);
}

export const getWallpaperById = (id:string) => {
    return filesOriginal('./'+id+'.png');
}

export const getColorByWallpaper = (key: string) =>{
    return {
        './w3.png': '#fff',
        './f1.png': '#fff',
        './f2.png': '#fff',
        './w6.png': '#fff',
        './l4.png': '#fff',
        './l2.png': '#fff',
    }[key] || '#000000';
}

export const getShadowColorByWallpaper = (key: string) =>{
    return {
        './w3.png': '#000',
        './f1.png': '#000',
        './f2.png': '#000',
        './w6.png': '#000',
        './l4.png': '#000',
        './l2.png': '#000',
    }[key] || '#fff';
}

